import HttpClientToken from '../../services/HttpClientToken';

import { TipoReservadoProps, defaultTipoReservado } from '../../interfaces/catalogos/TipoReservadoInterface';

export const TipoReservados = () => {

    return new Promise<TipoReservadoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoReservado/', token)
            .then( ({ data } : { data : TipoReservadoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoReservado = () => {

    return new Promise<TipoReservadoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoReservado/ObtenerTipoReservados', token)
            .then( ({ data } : { data : TipoReservadoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoReservado = ( params: TipoReservadoProps ) => {

    return new Promise<TipoReservadoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoReservado/Actualizar', params, token)
            .then( ({ data } : { data : TipoReservadoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoReservado } );
            });

        }

    });

}

export const AgregarTipoReservado = ( params: TipoReservadoProps ) => {

    return new Promise<TipoReservadoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoReservado/Agregar', params, token)
            .then( ({ data } : { data : TipoReservadoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoReservado } );
            });

        }

    });

}
